import { useEffect, useState } from "react";
import instance from "../services/axios";

const useNetflixSearch = (fetchUrl, runOneTime) => {
  const [movies, setMovies] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      instance.get(fetchUrl).then((res) => setMovies(res.data.results));
    };
    fetchData();
  }, [fetchUrl]);
  return movies;
};

export default useNetflixSearch;
